export function findGetParameter(parameterName) {
   var result = null,
       tmp = [];
   window.location.search
       .substr(1)
       .split("&")
       .forEach(function (item) {
         tmp = item.split("=");
         if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
       });
   return result;
}

export function insertParam(key, value)
{
    var url = window.location.href;
    window.history.pushState({}, "Hide", url+"?"+key+"="+value);
}


// WEBPACK FOOTER //
// ./src/SPRINTA/helpers/Url.js